import React from 'react';
import {getRowDataForColumnComponent} from 'js/common/griddle_column_helper';

const Checkbox = (isChecked, onChange) => props => {
    const {id, invite_id} = getRowDataForColumnComponent(props);
    return (
        <div>
            <input
                type="checkbox"
                id={id}
                value={id}
                name={invite_id}
                checked={isChecked(id)}
                onChange={event => onChange(id, event)}
            />
        </div>
    );
};

export default Checkbox;



// WEBPACK FOOTER //
// ./admin_operations/shipping/components/checkbox.js